import { render, staticRenderFns } from "./IPlay.vue?vue&type=template&id=142581b0&"
import script from "./IPlay.vue?vue&type=script&lang=ts&"
export * from "./IPlay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports